module.exports = __webpack_public_path__ + "static/publicidad-3e0e2e370d0c4c6a14fd34cffe88db3e.png";